<template>
  <div>
    <v-card>
      <v-card-title>
        Service and Security Settings
        <v-spacer></v-spacer>
        <v-btn icon
          ><v-icon color="dark" @click="cancel">mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-divider class="mx-4 mb-2"></v-divider>
      <v-card-text>
        <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
          <nbn-options
            :isAdding="isAdding"
            :userService="userService"
            @trigger-validation="validateForm"
            ref="options"
          ></nbn-options>
          <user-service
            :isAdding="isAdding"
            @get-ip="setGetIP"
            :userService="userService"
            @existingUsername="checkUsername"
          ></user-service>

          <edit-actions
            v-if="!isAdding"
            :isAdding="isAdding"
            :url="url"
            :target="target"
            :getIP="getIP"
            @request="request"
            @restartSession="restart"
            :userService="userService"
          ></edit-actions>

          <v-row>
            <v-col cols="12" class="my-3 py-0 px-0">
              <v-divider class="mx-3"></v-divider>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn
                @click.prevent="save"
                color="dark"
                class="white--text mr-4"
                :disabled="invalid || !dirty || isRadiusUsernameExisting"
                >Save</v-btn
              >
              <v-btn @click="cancel">Cancel</v-btn>
            </v-col>
          </v-row>
        </ValidationObserver>
      </v-card-text>
    </v-card>

    <v-dialog v-model="isRequesting" persistent width="350">
      <request-ip @cancel="isRequesting = false"></request-ip>
    </v-dialog>
  </div>
</template>


<script>
import { JsonParse } from "@/plugins/functions";
export default {
  name: "edit-service",
  data: () => ({
    getIP: "",
    getRateplan: "",
    restartSession: false,
    deleteStaticIp: false,
    isRequesting: false,
    url: "",
    target: "",
    selectedIP: "",
    groups: [],
    isRadiusUsernameExisting: false
  }),
  props: {
    isAdding: {
      type: Boolean,
    },
    userService: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  beforeMount() {
    let vm = this;
    if (vm.isAdding) vm.createEmptyService();
  },
  methods: {
    validateForm() {
      this.$nextTick(() => {
        const providers = this.$refs.observer.refs;
        console.log("Does it actually go?", providers)
        if (providers && Object.keys(providers).length > 0) {
          const firstProvider = Object.values(providers)[0];
          if (firstProvider) {
            firstProvider.setFlags({ dirty: true, touched: true });
          }
        }      
      });
    },
    setGetIP(val) {
      this.getIP = val;
    },
    getIpGroups() {
      let vm = this;
      vm.getGroupList().then(() => {
        vm.groups = vm.ipGroups.map((x) => x.ip_group);
      });
    },
    setIpGroup(data) {
      let vm = this;
      vm.selectedIP = data;
    },
    save() {
      let vm = this;
      let payload = {
        restartSession: vm.restartSession,
        deleteStaticIp: vm.deleteStaticIp,
        ipGroup: vm.userService.ipGroup,
        service: JsonParse(vm.userService),
      };

      vm.$emit("saved", payload);
    },
    cancel() {
      let vm = this;
      vm.restartSession = false;
      vm.selectedIP = "";
      vm.$refs.observer.reset();
      // vm.getService();
      vm.$emit("cancel");
    },
    request() {
      let vm = this;

      if (vm.userService.kayakoConversation) {
        vm.url = vm.userService.kayakoConversation;
        vm.target = "_blank";
      } else vm.isRequesting = true;
    },
    restart() {
      let vm = this;
      let payload = {
        restartSession: true,
        deleteStaticIp: vm.deleteStaticIp,
        ipGroup: vm.userService.ipGroup,
        service: JsonParse(vm.userService),
      };
      vm.updateService(payload);
      vm.restartSession = !vm.restartSession;
    },
    checkUsername(data) {
      this.isRadiusUsernameExisting = data
    }
  },
};
</script>

<style scoped>
.btn--save {
  color: #fff;
}

::v-deep .custom-btn {
  height: 105px !important;
  width: 100px;
  overflow: hidden;
}

::v-deep .custom-btn .v-btn__content {
  display: block !important;
  width: 100px;
}

::v-deep .custom-btn .v-btn__content span {
  margin: 10px 0 !important;
  display: block !important;
}

::v-deep .custom-btn .btn-font {
  font-size: 12px;
}
</style>
